export class SetDataCatalogDatasetAccessControlModeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accessControlMode",
            "baseName": "accessControlMode",
            "type": "DataCatalogDatasetAccessControlMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SetDataCatalogDatasetAccessControlModeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
